// // import React, { forwardRef, useEffect, useState } from 'react';
// // import { Box, Grid, Paper, Table, TableBody, TableContainer, TableHead, TableCell, TableRow, Typography } from '@mui/material';
// // import { StyledTableCellPrint, StyledTableRow } from '../../reusableComponent/Reusables';
// // import logo from '../../../images/logo-s.png';
// // import qa_image from '../../../images/logo-s.png';
// // import qoiImg from '../../../images/print_header.png';
// // import styles from '.././../../styles.module.css';
// // import trigaslogo from '../../../images/tri_gases.jpeg';
// // import depotMasterService from '../../../services/masters/depotMaster.Service';
// // import productMasterService from '../../../services/masters/productMaster.Service';
// // import vehicleMasterService from '../../../services/masters/vehicleMaster.Service';
// // import customerMasterService from '../../../services/masters/customerMaster.Service';

// // const DeliveryChallanPrint = forwardRef(({ printDetails }, ref) => {
// //   const login_details = sessionStorage.getItem('loginUser');
// //   const userD = JSON.parse(login_details);
// //   const userInfo = userD.result.userInfo;
// //   const depotId = Number(printDetails.depot_id || userInfo?.depot_id);

// //   const {
// //     totalCylinders,
// //     totalQuantity,
// //     productsSummary,
// //     customer_name,
// //     delivery_address,
// //     entry_no,
// //     entry_date,
// //     po_no,
// //     po_date,
// //     so_no,
// //     so_date,
// //     invoice_no,
// //     driver_name,
// //     prepared_by,
// //     product_code,
// //     to_customer_id,
// //     to_depot_id,
// //     vehicle_id,
// //     table_details,
// //     unregistered_driver,
// //     unregistered_vehicle,
// //   } = printDetails;

// //   console.log('printDetails:', printDetails);

// //   const [depots, SetDepost] = useState([]);
// //   const [products, SetProduct] = useState([]);
// //   const [vehicle, Setvehicle] = useState([]);
// //   const [successMessage, setSuccessMessage] = useState(null);
// //   const [isLoading, setIsLoading] = useState(true);
// //   const [customer, setCustomer] = useState([]);

// //   useEffect(() => {
// //     async function fetchData() {
// //       try {
// //         const depotData = await depotMasterService.getDepotList({
// //           page: 0,
// //           size: 10,
// //           searchKey: "",
// //         });
// //         const productData = await productMasterService.getProductList({
// //           page: 0,
// //           size: 10,
// //           searchKey: "",
// //         });
// //         const vehicleData = await vehicleMasterService.getVehicleList({
// //           page: 0,
// //           size: 10,
// //           searchKey: "",
// //         });

// //         const customerData = await customerMasterService.getCustomerList({
// //           page: 0,
// //           size: 10,
// //           searchKey: "",
// //         });

// //         SetDepost(depotData);
// //         SetProduct(productData);
// //         Setvehicle(vehicleData);
// //         setCustomer(customerData);
// //         setIsLoading(false);
// //       } catch (error) {
// //         console.error("Data fetching failed", error);
// //         setSuccessMessage("Error fetching dropdown data");
// //         setIsLoading(false);
// //       }
// //     }

// //     fetchData();
// //   }, []);

// //   // Get the depot and its address
// //   const depot = Array.isArray(depots)
// //     ? depots.find((d) => Number(d.depot_id) === depotId)
// //     : null;
// //   const depotAddress = depot?.depot_address || 'Depot address not found';

// //   // Get depot name for to_depot_id
// //   const depotName = Array.isArray(depots)
// //     ? depots.find(c => Number(c.depot_id) === Number(to_depot_id))?.depot_name
// //     : 'N/A';

// //   // Get vehicle number with fallback
// //   const vehicleno = unregistered_vehicle 
// //     ? unregistered_vehicle 
// //     : (Array.isArray(vehicle) 
// //         ? vehicle.find(p => Number(p.vehicle_id) === Number(vehicle_id))?.vehicle_no || 'Unknown Vehicle' 
// //         : 'Unknown Vehicle');

// //   // Get driver name with fallback
// //   const displayDriverName = unregistered_driver 
// //     ? unregistered_driver 
// //     : (driver_name || 'Nitin Mane');

// //   // Parse table_details
// //   const childRows = JSON.parse(table_details || '[]');

// //   const dateConversion = (date) => {
// //     if (!date) return 'N/A';
// //     var today = new Date(date);
// //     var dd = String(today.getDate()).padStart(2, "0");
// //     var mm = String(today.getMonth() + 1).padStart(2, "0");
// //     var yyyy = today.getFullYear();
// //     return `${dd}/${mm}/${yyyy}`;
// //   };

// //   useEffect(() => {
// //     if (entry_no) {
// //       document.title = `DC_${entry_no}`;
// //     } else {
// //       document.title = 'Delivery_Challan';
// //     }
// //   }, [entry_no]);

// //   const getProductCodes = () => {
// //     if (!Array.isArray(childRows) || !Array.isArray(products)) {
// //       return product_code || 'None';
// //     }

// //     const productCountMap = {};
// //     childRows.forEach(row => {
// //       const prodId = Number(row.prod_id);
// //       productCountMap[prodId] = (productCountMap[prodId] || 0) + 1;
// //     });

// //     const result = Object.entries(productCountMap).map(([prodId, count]) => {
// //       const product = products.find(p => Number(p.prod_id) === Number(prodId));
// //       if (product) {
// //         return `${product.prod_code} (${count})`;
// //       }
// //       return null;
// //     }).filter(Boolean);

// //     return result.length > 0 ? result.join(', ') : product_code || 'None';
// //   };

// //   if (isLoading) {
// //     return <Typography>Loading...</Typography>;
// //   }

// //   const getCustomerCylinderCount = () => {
// //     if (!Array.isArray(childRows)) return 0;
// //     const customerCylinders = childRows.filter(row => row.owner !== 'TGPL').length;
// //     return customerCylinders || 0;
// //   };
// //   const totalBillQty = childRows.reduce((sum, row) => sum + Number(row.bill_qty || 0), 0);

// //   return (
// //     <Box className="print-source" style={{ margin: '30px' }}>
// //       <Box sx={{ margin: '55px 15px 30px 15px', boxShadow: 'none', height: '90vh', backgroundColor: '#ffffff', paddingLeft: '20px !important' }}>
// //         <Grid container>
// //           <Grid item xs={10}>
// //           <Box style={{
// //               backgroundImage: `url(${qoiImg})`,
// //               backgroundRepeat: 'no-repeat',
// //               backgroundSize: 'cover',
// //               backgroundPosition: 'center',
// //               height: '60px',
// //               width: '100% !important',
// //               display: 'flex',
// //               textAlign: 'center',
// //               alignItems: 'center'
// //             }}>
// //               <Typography sx={{ textAlign: 'start', textAlign: 'center', marginLeft: '10px', fontSize: '26px', fontWeight: 'bold', padding: '1px', color: '#ffffff', textTransform: 'uppercase' }}>
// //                 Delivery Challan
// //               </Typography>
// //           </Box>
// //         <Box>
// //               <Typography sx={{ fontWeight: 'bold', fontSize: '18px' }}>
// //                 TRI GASES PVT. LTD.
// //               </Typography>
// //               <Typography sx={{ fontSize: '12px' }}>
// //                 {depotAddress}
// //               </Typography>
// //               <Typography sx={{ fontSize: '12px' }}>
// //                 Email - demotes1234@gmail.com
// //               </Typography>
// //               <Typography sx={{ fontSize: '12px' }}>
// //                 Website - www.trigases.com
// //               </Typography>
// //               <Typography sx={{ fontSize: '12px' }}>
// //                 GSTIN - 27AADCT2097G1Z7
// //               </Typography>
// //             </Box>
// //           </Grid>
// //           <Grid item xs={2}>
// //             <Box sx={{ justifyContent: 'flex-end', alignItems: 'flex-end', width: '100%', display: 'flex' }}>
// //               <img src={trigaslogo} style={{ width: 'auto', height: '150px', justifyContent: 'flex-end', display: 'flex' }} />
// //             </Box>
// //           </Grid>
// //           <Grid item xs={12} sx={{ borderTop: '1px solid #616161', backgroundColor: '#f0f0f0', minHeight: '10px', marginTop: '8px' }}></Grid>
// //         </Grid>
// //         <Box>
// //           <Grid container spacing={0.6}>
// //             <Grid item xs={12} sm={7}>
// //               <Box>
// //                 <Typography sx={{ fontWeight: 'bold', fontSize: '18px' }}>
// //                   {customer_name || `TRI GASES PVT. LTD., ${depotName || 'N/A'}`}
// //                 </Typography>
// //                 {customer_name && delivery_address && (
// //                   <Typography className={styles.info_txt_ans}>
// //                     {delivery_address}
// //                   </Typography>
// //                 )}
// //                 {!customer_name && depotName && printDetails.other_depot_address && (
// //                   <Typography className={styles.info_txt_ans}>
// //                     {printDetails.other_depot_address}
// //                   </Typography>
// //                 )}
// //                 {printDetails.contact_no && (
// //                   <Box className={`${styles.print_label_container}`}>
// //                     <Typography className={styles.info_txt2}>Contact No :</Typography>
// //                     <Typography className={styles.info_txt_ans}>{printDetails.contact_no || 'N/A'}</Typography>
// //                   </Box>
// //                 )}
// //                 <Box className={`${styles.print_label_container}`}>
// //                   <Typography className={styles.info_txt2}>Product Code :</Typography>
// //                   <Typography className={styles.info_txt_ans2}>{product_code || 'N/A'}</Typography>
// //                 </Box>
// //                 <Box className={`${styles.print_label_container}`}>
// //                   <Typography className={styles.info_txt2}>Prepared By :</Typography>
// //                   <Typography className={styles.info_txt_ans2}>{prepared_by || 'N/A'}</Typography>
// //                 </Box>
// //               </Box>
// //             </Grid>
// //             <Grid item xs={12} sm={5}>
// //               <Box className={`${styles.print_label_container}`}>
// //                 <Box className={`${styles.print_label_container}`}>
// //                   <Typography className={styles.info_txt2}>DC No : </Typography>
// //                   <Typography className={styles.info_txt_ans2}>{entry_no || 'N/A'}</Typography>
// //                 </Box>
// //                 <Box className={`${styles.print_label_container}`}>
// //                   <Typography className={styles.info_txt2}>Date :</Typography>
// //                   <Typography className={styles.info_txt_ans2}>{dateConversion(entry_date)}</Typography>
// //                 </Box>
// //               </Box>
// //               <Box className={`${styles.print_label_container}`}>
// //                 <Box className={`${styles.print_label_container}`}>
// //                   <Typography className={styles.info_txt2}>PO No : </Typography>
// //                   <Typography className={styles.info_txt_ans2}>{po_no || 'N/A'}</Typography>
// //                 </Box>
// //                 <Box className={`${styles.print_label_container}`}>
// //                   <Typography className={styles.info_txt2}>Date :</Typography>
// //                   <Typography className={styles.info_txt_ans2}>{dateConversion(po_date)}</Typography>
// //                 </Box>
// //               </Box>
// //               <Box className={`${styles.print_label_container}`}>
// //                 <Box className={`${styles.print_label_container}`}>
// //                   <Typography className={styles.info_txt2}>SO No :</Typography>
// //                   <Typography className={styles.info_txt_ans2}>{so_no || 'N/A'}</Typography>
// //                 </Box>
// //                 <Box className={`${styles.print_label_container}`}>
// //                   <Typography className={styles.info_txt2}>Date :</Typography>
// //                   <Typography className={styles.info_txt_ans2}>{dateConversion(so_date)}</Typography>
// //                 </Box>
// //               </Box>
// //               <Box className={`${styles.print_label_container}`}>
// //                 <Typography className={styles.info_txt2}>Invoice :</Typography>
// //                 <Typography className={styles.info_txt_ans2}>{invoice_no || 'N/A'}</Typography>
// //               </Box>
// //               <Box className={`${styles.print_label_container}`}>
// //                 <Typography className={styles.info_txt2}>Vehicle :</Typography>
// //                 <Typography className={styles.info_txt_ans2}>{vehicleno}</Typography>
// //               </Box>
// //               <Box className={`${styles.print_label_container}`}>
// //                 <Typography className={styles.info_txt2}>Driver :</Typography>
// //                 <Typography className={styles.info_txt_ans2}>{displayDriverName}</Typography>
// //               </Box>
// //             </Grid>
// //           </Grid>
// //         </Box>
// //         <TableContainer component={Paper} className={`${styles.list_tbl_container}`} sx={{ boxShadow: 'none' }}>
// //           <Grid container spacing={2}>
// //             {[0, 1].map((colIndex) => {
// //               const startIndex = colIndex * 24;
// //               const rowsForColumn = childRows.slice(startIndex, startIndex + 24);
// //               return (
// //                 <Grid item xs={6} md={6} key={colIndex} sx={{ height: '90% !important' }}>
// //                   <Table size="small">
// //                     <TableHead>
// //                       <StyledTableRow>
// //                         <StyledTableCellPrint align="center" className={styles.table_head}>Sr no</StyledTableCellPrint>
// //                         <StyledTableCellPrint align="center" className={styles.table_head}>Cylinder No</StyledTableCellPrint>
// //                         <StyledTableCellPrint align="center" className={styles.table_head}>Qty</StyledTableCellPrint>
// //                         <StyledTableCellPrint align="center" className={styles.table_head}>Owner</StyledTableCellPrint>
// //                       </StyledTableRow>
// //                     </TableHead>
// //                     <TableBody>
// //                       {rowsForColumn.map((row, index) => (
// //                         <StyledTableRow key={index}>
// //                           <StyledTableCellPrint align="center" className={styles.print_table_body}>
// //                             {startIndex + index + 1}
// //                           </StyledTableCellPrint>
// //                           <StyledTableCellPrint align="center" className={styles.print_table_body}>
// //                             {row.cyl_no}
// //                           </StyledTableCellPrint>
// //                           <StyledTableCellPrint align="center" className={styles.print_table_body}>
// //                             {row.bill_qty} m³
// //                           </StyledTableCellPrint>
// //                           <StyledTableCellPrint align="center" className={styles.print_table_body}>
// //                             {row.owner}
// //                           </StyledTableCellPrint>
// //                         </StyledTableRow>
// //                       ))}
// //                     </TableBody>
// //                   </Table>
// //                 </Grid>
// //               );
// //             })}
// //           </Grid>
// //         </TableContainer>
// //         <br />
// //         <Box style={{ borderTop: '1px solid #616161', backgroundColor: '#f0f0f0', minHeight: '10px' }}></Box>
// //         <Box sx={{ textAlign: 'left' }}>
// //           <Grid container>
// //             <Grid item xs={8}></Grid>
// //           </Grid>
// //         </Box>
// //         <Box className={`${styles.footer}`}>
// //           <Table className={`${styles.footerTable}`}>
// //             <TableBody>
// //               <TableRow>
// //                 <TableCell sx={{ paddingLeft: '0px !important', marginLeft: '0px !important', paddingRight: '0px !important', marginRight: '0px !important' }}>
// //                   <Box sx={{ padding: '0px !important', margin: '0px !important' }}>
// //                     <Box className={`${styles.summaryItem}`} sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'row' } }}>
// //                       <Typography className={`${styles.label_Txt_add}`}>
// //                         TGPL Cyl:
// //                       </Typography>
// //                       <Typography className={`${styles.summary_ans}`}>
// //                         {totalCylinders || '0'}
// //                       </Typography>
// //                     </Box>
// //                     <Box className={`${styles.summaryItem}`} sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'row' } }}>
// //                       <Typography className={`${styles.label_Txt_add}`}>
// //                         Customer Cyl:
// //                       </Typography>
// //                       <Typography className={`${styles.summary_ans}`}>
// //                         {getCustomerCylinderCount()}
// //                       </Typography>
// //                     </Box>
// //                     <Box className={`${styles.summaryItem}`} sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'row' } }}>
// //                       <Typography className={`${styles.label_Txt_add}`}>
// //                         Total Qty:
// //                       </Typography>
// //                       <Typography className={`${styles.summary_ans}`}>
// //   {Number(totalBillQty).toFixed(2)} m³s
// // </Typography>

// //                     </Box>
// //                   </Box>
// //                 </TableCell>
// //                 <TableCell>
// //                   <Box>
// //                     <Box sx={{ mt: 9 }}>
// //                       <Typography className={`${styles.authorized_txt}`}>
// //                         Receiver Signatory
// //                       </Typography>
// //                     </Box>
// //                   </Box>
// //                 </TableCell>
// //                 <TableCell>
// //                   <Box>
// //                     <Typography className={`${styles.footer_txt}`}>
// //                       For <span className={`${styles.footer_txt_bold}`}>TRI GASES PVT. LTD.</span>
// //                     </Typography>
// //                     <Box sx={{ mt: 7 }}>
// //                       <Typography className={`${styles.authorized_txt}`}>
// //                         Authorized Signatory
// //                       </Typography>
// //                     </Box>
// //                   </Box>
// //                 </TableCell>
// //               </TableRow>
// //             </TableBody>
// //           </Table>
// //         </Box>
// //       </Box>
// //     </Box>
// //   );
// // });

// // export default DeliveryChallanPrint;


// import React, { forwardRef, useEffect, useState } from 'react';
// import { Box, Grid, Paper, Table, TableBody, TableContainer, TableHead, TableCell, TableRow, Typography } from '@mui/material';
// import { StyledTableCellPrint, StyledTableRow } from '../../reusableComponent/Reusables';
// import logo from '../../../images/logo-s.png';
// import qa_image from '../../../images/logo-s.png';
// import qoiImg from '../../../images/print_header.png';
// import styles from '.././../../styles.module.css';
// import trigaslogo from '../../../images/tri_gases.jpeg';
// import depotMasterService from '../../../services/masters/depotMaster.Service';
// import productMasterService from '../../../services/masters/productMaster.Service';
// import vehicleMasterService from '../../../services/masters/vehicleMaster.Service';
// import customerMasterService from '../../../services/masters/customerMaster.Service';

// // ── All CSS for this print layout lives here (no separate .css file needed) ──
// const dcPrintStyles = `
//   .dc-print-table-head {
//     color: #ffffff !important;
//     font-family: Inter, sans-serif !important;
//     font-size: 11px !important;
//     font-weight: 600 !important;
//     padding: 5px 3px !important;
//     line-height: 14px !important;
//     background-color: #1C3A5E !important;
//     white-space: nowrap;
//   }

//   .dc-print-table-body {
//     color: rgba(25, 39, 57, 0.94) !important;
//     font-family: Inter, sans-serif !important;
//     font-size: 11px !important;
//     padding: 2px 3px !important;
//     line-height: 13px !important;
//     height: 16px !important;
//     white-space: nowrap;
//   }

//   @media print {
//     @page {
//       size: A4;
//       margin: 10mm 8mm 12mm 8mm;
//     }
//   }

//   /* Custom page number in the printable footer area (bottom-right).
//      If your browser doesn't render this, turn OFF "Headers and footers"
//      in the Print dialog's "More settings" instead. */
//   @page {
//     @bottom-right {
//       content: "Page " counter(page) " of " counter(pages);
//       font-size: 9px;
//       color: #444;
//     }
//   }
// `;

// const DeliveryChallanPrint = forwardRef(({ printDetails }, ref) => {
//   useEffect(() => {
//     const styleSheet = document.createElement('style');
//     styleSheet.type = 'text/css';
//     styleSheet.innerText = dcPrintStyles;
//     document.head.appendChild(styleSheet);
//     return () => { document.head.removeChild(styleSheet); };
//   }, []);

//   const login_details = sessionStorage.getItem('loginUser');
//   const userD = JSON.parse(login_details);
//   const userInfo = userD.result.userInfo;
//   const depotId = Number(printDetails.depot_id || userInfo?.depot_id);

//   const {
//     totalCylinders,
//     totalQuantity,
//     productsSummary,
//     customer_name,
//     delivery_address,
//     entry_no,
//     entry_date,
//     po_no,
//     po_date,
//     so_no,
//     so_date,
//     invoice_no,
//     driver_name,
//     prepared_by,
//     product_code,
//     to_customer_id,
//     to_depot_id,
//     vehicle_id,
//     table_details,
//     unregistered_driver,
//     unregistered_vehicle,
//   } = printDetails;

//   console.log('printDetails:', printDetails);

//   const [depots, SetDepost] = useState([]);
//   const [products, SetProduct] = useState([]);
//   const [vehicle, Setvehicle] = useState([]);
//   const [successMessage, setSuccessMessage] = useState(null);
//   const [isLoading, setIsLoading] = useState(true);
//   const [customer, setCustomer] = useState([]);

//   useEffect(() => {
//     async function fetchData() {
//       try {
//         const depotData = await depotMasterService.getDepotList({
//           page: 0,
//           size: 10,
//           searchKey: "",
//         });
//         const productData = await productMasterService.getProductList({
//           page: 0,
//           size: 10,
//           searchKey: "",
//         });
//         const vehicleData = await vehicleMasterService.getVehicleList({
//           page: 0,
//           size: 10,
//           searchKey: "",
//         });

//         const customerData = await customerMasterService.getCustomerList({
//           page: 0,
//           size: 10,
//           searchKey: "",
//         });

//         SetDepost(depotData);
//         SetProduct(productData);
//         Setvehicle(vehicleData);
//         setCustomer(customerData);
//         setIsLoading(false);
//       } catch (error) {
//         console.error("Data fetching failed", error);
//         setSuccessMessage("Error fetching dropdown data");
//         setIsLoading(false);
//       }
//     }

//     fetchData();
//   }, []);

//   // Get the depot and its address
//   const depot = Array.isArray(depots)
//     ? depots.find((d) => Number(d.depot_id) === depotId)
//     : null;
//   const depotAddress = depot?.depot_address || 'Depot address not found';

//   // Get depot name for to_depot_id
//   const depotName = Array.isArray(depots)
//     ? depots.find(c => Number(c.depot_id) === Number(to_depot_id))?.depot_name
//     : 'N/A';

//   // ── Point 3: customer code lookup (fields confirmed from DeliveryChallanAdd.jsx: cust_id / cust_code) ──
//   const customerCode = Array.isArray(customer)
//     ? customer.find(c => Number(c.cust_id) === Number(to_customer_id))?.cust_code
//     : null;

//   // Get vehicle number with fallback
//   const vehicleno = unregistered_vehicle 
//     ? unregistered_vehicle 
//     : (Array.isArray(vehicle) 
//         ? vehicle.find(p => Number(p.vehicle_id) === Number(vehicle_id))?.vehicle_no || 'Unknown Vehicle' 
//         : 'Unknown Vehicle');

//   // Get driver name with fallback
//   const displayDriverName = unregistered_driver 
//     ? unregistered_driver 
//     : (driver_name || 'Nitin Mane');

//   // Parse table_details
//   const childRows = JSON.parse(table_details || '[]');

//   const dateConversion = (date) => {
//     if (!date) return 'N/A';
//     var today = new Date(date);
//     var dd = String(today.getDate()).padStart(2, "0");
//     var mm = String(today.getMonth() + 1).padStart(2, "0");
//     var yyyy = today.getFullYear();
//     return `${dd}/${mm}/${yyyy}`;
//   };

//   useEffect(() => {
//     if (entry_no) {
//       document.title = `DC_${entry_no}`;
//     } else {
//       document.title = 'Delivery_Challan';
//     }
//   }, [entry_no]);

//   const getProductCodes = () => {
//     if (!Array.isArray(childRows) || !Array.isArray(products)) {
//       return product_code || 'None';
//     }

//     const productCountMap = {};
//     childRows.forEach(row => {
//       const prodId = Number(row.prod_id);
//       productCountMap[prodId] = (productCountMap[prodId] || 0) + 1;
//     });

//     const result = Object.entries(productCountMap).map(([prodId, count]) => {
//       const product = products.find(p => Number(p.prod_id) === Number(prodId));
//       if (product) {
//         return `${product.prod_code} (${count})`;
//       }
//       return null;
//     }).filter(Boolean);

//     return result.length > 0 ? result.join(', ') : product_code || 'None';
//   };

//   if (isLoading) {
//     return <Typography>Loading...</Typography>;
//   }

//   const getCustomerCylinderCount = () => {
//     if (!Array.isArray(childRows)) return 0;
//     const customerCylinders = childRows.filter(row => row.owner !== 'TGPL').length;
//     return customerCylinders || 0;
//   };
//   const totalBillQty = childRows.reduce((sum, row) => sum + Number(row.bill_qty || 0), 0);

//   // ── Point 3: inter-depot transfer detection + From/To values ──
//   // customer_name present  -> DC going to a customer -> show customer code instead of name/address
//   // customer_name absent   -> DC going to another depot -> show From (this depot) / To (target depot)
//   const isInterDepotTransfer = !customer_name && !!depotName;
//   const toDisplayValue = customer_name
//     ? (customerCode || customer_name) // fallback to name if code not found
//     : (depotName || 'N/A');

//   // ── Point 4: 3 columns x 20 rows per column = 60 cylinders per page ──
//   const COLUMN_COUNT = 3;
//   const ROWS_PER_COLUMN = 20;
//   const columnWidth = 12 / COLUMN_COUNT; // xs grid width per column

//   return (
//     <Box className="print-source" style={{ margin: '10px' }}>
//       {/* ── height:'90vh' removed — that fixed height was squeezing the 3-column table and causing scroll/clipping in print ── */}
//       <Box sx={{ margin: '25px 10px 10px 10px', boxShadow: 'none', height: 'auto', backgroundColor: '#ffffff', paddingLeft: '20px !important' }}>
//         <Grid container>
//           <Grid item xs={10}>
//           <Box style={{
//               backgroundImage: `url(${qoiImg})`,
//               backgroundRepeat: 'no-repeat',
//               backgroundSize: 'cover',
//               backgroundPosition: 'center',
//               height: '60px',
//               width: '100% !important',
//               display: 'flex',
//               textAlign: 'center',
//               alignItems: 'center'
//             }}>
//               <Typography sx={{ textAlign: 'start', textAlign: 'center', marginLeft: '10px', fontSize: '26px', fontWeight: 'bold', padding: '1px', color: '#ffffff', textTransform: 'uppercase' }}>
//                 Delivery Challan
//               </Typography>
//           </Box>
//         <Box>
//               <Typography sx={{ fontWeight: 'bold', fontSize: '18px' }}>
//                 TRI GASES PVT. LTD.
//               </Typography>
//               <Typography sx={{ fontSize: '12px' }}>
//                 {depotAddress}
//               </Typography>
//               <Typography sx={{ fontSize: '12px' }}>
//                 Email - demotes1234@gmail.com
//               </Typography>
//               <Typography sx={{ fontSize: '12px' }}>
//                 Website - www.trigases.com
//               </Typography>
//               <Typography sx={{ fontSize: '12px' }}>
//                 GSTIN - 27AADCT2097G1Z7
//               </Typography>
//             </Box>
//           </Grid>
//           <Grid item xs={2}>
//             <Box sx={{ justifyContent: 'flex-end', alignItems: 'flex-end', width: '100%', display: 'flex' }}>
//               <img src={trigaslogo} style={{ width: 'auto', height: '150px', justifyContent: 'flex-end', display: 'flex' }} />
//             </Box>
//           </Grid>
//           {/* ── Point 1: divider REMOVED from here (was above Date/DC block) ── */}
//         </Grid>
//         <Box>
//           <Grid container spacing={0.6}>
//             <Grid item xs={12} sm={7}>
//               <Box>
//                 {isInterDepotTransfer ? (
//                   <>
//                     {/* ── Point 3: inter-depot transfer → From / To format ── */}
//                     <Box className={`${styles.print_label_container}`}>
//                       <Typography className={styles.info_txt2}>From :</Typography>
//                       <Typography className={styles.info_txt_ans2}>{depot?.depot_name || 'N/A'}</Typography>
//                     </Box>
//                     <Box className={`${styles.print_label_container}`}>
//                       <Typography className={styles.info_txt2}>To :</Typography>
//                       <Typography className={styles.info_txt_ans2}>{toDisplayValue}</Typography>
//                     </Box>
//                   </>
//                 ) : (
//                   <>
//                     {/* ── Point 3: customer DC → Customer Code only, no full name/address ── */}
//                     <Box className={`${styles.print_label_container}`}>
//                       <Typography className={styles.info_txt2}>Customer Code :</Typography>
//                       <Typography sx={{ fontWeight: 'bold', fontSize: '16px' }}>
//                         {customerCode || customer_name || 'N/A'}
//                       </Typography>
//                     </Box>
//                   </>
//                 )}
//                 {printDetails.contact_no && (
//                   <Box className={`${styles.print_label_container}`}>
//                     <Typography className={styles.info_txt2}>Contact No :</Typography>
//                     <Typography className={styles.info_txt_ans}>{printDetails.contact_no || 'N/A'}</Typography>
//                   </Box>
//                 )}
//                 <Box className={`${styles.print_label_container}`}>
//                   <Typography className={styles.info_txt2}>Product Code :</Typography>
//                   <Typography className={styles.info_txt_ans2}>{product_code || 'N/A'}</Typography>
//                 </Box>
//                 <Box className={`${styles.print_label_container}`}>
//                   <Typography className={styles.info_txt2}>Prepared By :</Typography>
//                   <Typography className={styles.info_txt_ans2}>{prepared_by || 'N/A'}</Typography>
//                 </Box>
//               </Box>
//             </Grid>
//             <Grid item xs={12} sm={5}>
//               <Box className={`${styles.print_label_container}`}>
//                 <Box className={`${styles.print_label_container}`}>
//                   <Typography className={styles.info_txt2}>DC No : </Typography>
//                   <Typography className={styles.info_txt_ans2}>{entry_no || 'N/A'}</Typography>
//                 </Box>
//                 <Box className={`${styles.print_label_container}`}>
//                   <Typography className={styles.info_txt2}>Date :</Typography>
//                   <Typography className={styles.info_txt_ans2}>{dateConversion(entry_date)}</Typography>
//                 </Box>
//               </Box>
//               <Box className={`${styles.print_label_container}`}>
//                 <Box className={`${styles.print_label_container}`}>
//                   <Typography className={styles.info_txt2}>PO No : </Typography>
//                   <Typography className={styles.info_txt_ans2}>{po_no || 'N/A'}</Typography>
//                 </Box>
//                 <Box className={`${styles.print_label_container}`}>
//                   <Typography className={styles.info_txt2}>Date :</Typography>
//                   <Typography className={styles.info_txt_ans2}>{dateConversion(po_date)}</Typography>
//                 </Box>
//               </Box>
//               <Box className={`${styles.print_label_container}`}>
//                 <Box className={`${styles.print_label_container}`}>
//                   <Typography className={styles.info_txt2}>SO No :</Typography>
//                   <Typography className={styles.info_txt_ans2}>{so_no || 'N/A'}</Typography>
//                 </Box>
//                 <Box className={`${styles.print_label_container}`}>
//                   <Typography className={styles.info_txt2}>Date :</Typography>
//                   <Typography className={styles.info_txt_ans2}>{dateConversion(so_date)}</Typography>
//                 </Box>
//               </Box>
//               <Box className={`${styles.print_label_container}`}>
//                 <Typography className={styles.info_txt2}>Invoice :</Typography>
//                 <Typography className={styles.info_txt_ans2}>{invoice_no || 'N/A'}</Typography>
//               </Box>
//               <Box className={`${styles.print_label_container}`}>
//                 <Typography className={styles.info_txt2}>Vehicle :</Typography>
//                 <Typography className={styles.info_txt_ans2}>{vehicleno}</Typography>
//               </Box>
//               <Box className={`${styles.print_label_container}`}>
//                 <Typography className={styles.info_txt2}>Driver :</Typography>
//                 <Typography className={styles.info_txt_ans2}>{displayDriverName}</Typography>
//               </Box>
//             </Grid>
//           </Grid>

//           {/* ── Point 1: divider MOVED here — now below Date/DC info, above the cylinder table ── */}
//           <Grid container>
//             <Grid item xs={12} sx={{ borderTop: '1px solid #616161', backgroundColor: '#f0f0f0', minHeight: '10px', marginTop: '8px', marginBottom: '8px' }}></Grid>
//           </Grid>
//         </Box>
//         <TableContainer component={Paper} className={`${styles.list_tbl_container}`} sx={{ boxShadow: 'none', overflowX: 'visible', overflowY: 'visible' }}>
//           <Grid container spacing={1}>
//             {/* ── Point 4: 3 columns x 20 rows each = 60 cylinders per page ── */}
//             {Array.from({ length: COLUMN_COUNT }, (_, i) => i).map((colIndex) => {
//               const startIndex = colIndex * ROWS_PER_COLUMN;
//               const rowsForColumn = childRows.slice(startIndex, startIndex + ROWS_PER_COLUMN);
//               return (
//                 <Grid item xs={columnWidth} md={columnWidth} key={colIndex} sx={{ height: '90% !important' }}>
//                   <Table size="small" sx={{ tableLayout: 'fixed', width: '100%' }}>
//                     <TableHead>
//                       <StyledTableRow>
//                         <StyledTableCellPrint align="center" className="dc-print-table-head">Sr no</StyledTableCellPrint>
//                         <StyledTableCellPrint align="center" className="dc-print-table-head">Cyl No</StyledTableCellPrint>
//                         <StyledTableCellPrint align="center" className="dc-print-table-head">Qty</StyledTableCellPrint>
//                         <StyledTableCellPrint align="center" className="dc-print-table-head">Owner</StyledTableCellPrint>
//                       </StyledTableRow>
//                     </TableHead>
//                     <TableBody>
//                       {rowsForColumn.map((row, index) => (
//                         <StyledTableRow key={index}>
//                           <StyledTableCellPrint align="center" className="dc-print-table-body">
//                             {startIndex + index + 1}
//                           </StyledTableCellPrint>
//                           <StyledTableCellPrint align="center" className="dc-print-table-body">
//                             {row.cyl_no}
//                           </StyledTableCellPrint>
//                           <StyledTableCellPrint align="center" className="dc-print-table-body">
//                             {row.bill_qty} m³
//                           </StyledTableCellPrint>
//                           <StyledTableCellPrint align="center" className="dc-print-table-body">
//                             {row.owner}
//                           </StyledTableCellPrint>
//                         </StyledTableRow>
//                       ))}
//                     </TableBody>
//                   </Table>
//                 </Grid>
//               );
//             })}
//           </Grid>
//         </TableContainer>
//         <br />
//         <Box style={{ borderTop: '1px solid #616161', backgroundColor: '#f0f0f0', minHeight: '10px' }}></Box>
//         <Box sx={{ textAlign: 'left' }}>
//           <Grid container>
//             <Grid item xs={8}></Grid>
//           </Grid>
//         </Box>
//         <Box className={`${styles.footer}`}>
//           <Table className={`${styles.footerTable}`}>
//             <TableBody>
//               <TableRow>
//                 <TableCell sx={{ paddingLeft: '0px !important', marginLeft: '0px !important', paddingRight: '0px !important', marginRight: '0px !important' }}>
//                   <Box sx={{ padding: '0px !important', margin: '0px !important' }}>
//                     <Box className={`${styles.summaryItem}`} sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'row' } }}>
//                       <Typography className={`${styles.label_Txt_add}`}>
//                         TGPL Cyl:
//                       </Typography>
//                       <Typography className={`${styles.summary_ans}`}>
//                         {totalCylinders || '0'}
//                       </Typography>
//                     </Box>
//                     <Box className={`${styles.summaryItem}`} sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'row' } }}>
//                       <Typography className={`${styles.label_Txt_add}`}>
//                         Customer Cyl:
//                       </Typography>
//                       <Typography className={`${styles.summary_ans}`}>
//                         {getCustomerCylinderCount()}
//                       </Typography>
//                     </Box>
//                     <Box className={`${styles.summaryItem}`} sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'row' } }}>
//                       <Typography className={`${styles.label_Txt_add}`}>
//                         Total Qty:
//                       </Typography>
//                       <Typography className={`${styles.summary_ans}`}>
//   {Number(totalBillQty).toFixed(2)} m³s
// </Typography>

//                     </Box>
//                   </Box>
//                 </TableCell>
//                 <TableCell>
//                   <Box>
//                     <Box sx={{ mt: 9 }}>
//                       <Typography className={`${styles.authorized_txt}`}>
//                         Receiver Signatory
//                       </Typography>
//                     </Box>
//                   </Box>
//                 </TableCell>
//                 <TableCell>
//                   <Box>
//                     <Typography className={`${styles.footer_txt}`}>
//                       For <span className={`${styles.footer_txt_bold}`}>TRI GASES PVT. LTD.</span>
//                     </Typography>
//                     <Box sx={{ mt: 7 }}>
//                       <Typography className={`${styles.authorized_txt}`}>
//                         Authorized Signatory
//                       </Typography>
//                     </Box>
//                   </Box>
//                 </TableCell>
//               </TableRow>
//             </TableBody>
//           </Table>
//         </Box>
//       </Box>
//     </Box>
//   );
// });

// export default DeliveryChallanPrint;



import React, { forwardRef, useEffect, useState } from 'react';
import { Box, Grid, Paper, Table, TableBody, TableContainer, TableHead, TableCell, TableRow, Typography } from '@mui/material';
import { StyledTableCellPrint, StyledTableRow } from '../../reusableComponent/Reusables';
import logo from '../../../images/logo-s.png';
import qa_image from '../../../images/logo-s.png';
import qoiImg from '../../../images/print_header.png';
import styles from '.././../../styles.module.css';
import trigaslogo from '../../../images/tri_gases.jpeg';
import depotMasterService from '../../../services/masters/depotMaster.Service';
import productMasterService from '../../../services/masters/productMaster.Service';
import vehicleMasterService from '../../../services/masters/vehicleMaster.Service';
import customerMasterService from '../../../services/masters/customerMaster.Service';

// ── All CSS for this print layout lives here (no separate .css file needed) ──
const dcPrintStyles = `
  .dc-print-table-head {
  color: #ffffff !important;
  font-family: Inter, sans-serif !important;
  font-size: 12px !important;
  font-weight: 600 !important;
  padding: 10px 6px !important;
  line-height: 16px !important;
  background-color: #1C3A5E !important;
  white-space: nowrap;
}

.dc-print-table-body {
  color: rgba(25, 39, 57, 0.94) !important;
  font-family: Inter, sans-serif !important;
  font-size: 12px !important;
  padding: 9px 6px !important;
  line-height: 16px !important;
  height: 32px !important;
  white-space: nowrap;
}
   @media print {
    @page {
      size: A4;
      margin: 4mm 8mm 12mm 8mm;
    }

    .print-source .dc-print-footer {
      position: static !important;
      left: auto !important;
      right: auto !important;
      bottom: auto !important;
      width: 100% !important;
      z-index: auto !important;
      padding-left: 0 !important;
      padding-right: 0 !important;
      margin-top: 8px !important;
      break-inside: avoid !important;
      page-break-inside: avoid !important;
    }

    .dc-print-table-body {
      padding: 4px 6px !important;
      height: 24px !important;
    }
    .dc-print-table-head {
      padding: 6px 6px !important;
    }
  }

  /* Custom page number in the printable footer area (bottom-right).
     If your browser doesn't render this, turn OFF "Headers and footers"
     in the Print dialog's "More settings" instead. */
  @page {
    @bottom-right {
      content: "Page " counter(page) " of " counter(pages);
      font-size: 9px;
      color: #444;
    }
  }
`;

const DeliveryChallanPrint = forwardRef(({ printDetails }, ref) => {
  useEffect(() => {
    const styleSheet = document.createElement('style');
    styleSheet.type = 'text/css';
    styleSheet.innerText = dcPrintStyles;
    document.head.appendChild(styleSheet);
    return () => { document.head.removeChild(styleSheet); };
  }, []);

  const login_details = sessionStorage.getItem('loginUser');
  const userD = JSON.parse(login_details);
  const userInfo = userD.result.userInfo;
  const depotId = Number(printDetails.depot_id || userInfo?.depot_id);

  const {
    totalCylinders,
    totalQuantity,
    productsSummary,
    customer_name,
    delivery_address,
    entry_no,
    entry_date,
    po_no,
    po_date,
    so_no,
    so_date,
    invoice_no,
    driver_name,
    prepared_by,
    product_code,
    to_customer_id,
    to_depot_id,
    vehicle_id,
    vehicle_no,
    table_details,
    unregistered_driver,
    unregistered_vehicle,
  } = printDetails;

  console.log('printDetails:', printDetails);

  const [depots, SetDepost] = useState([]);
  const [products, SetProduct] = useState([]);
  const [vehicle, Setvehicle] = useState([]);
  const [successMessage, setSuccessMessage] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [customer, setCustomer] = useState([]);

  useEffect(() => {
    async function fetchData() {
      try {
        const depotData = await depotMasterService.getDepotList({
          page: 0,
          size: 10,
          searchKey: "",
        });
        const productData = await productMasterService.getProductList({
          page: 0,
          size: 10,
          searchKey: "",
        });
        const vehicleData = await vehicleMasterService.getVehicleList({
          page: 0,
          size: 10,
          searchKey: "",
        });

        const customerData = await customerMasterService.getCustomerList({
          page: 0,
          size: 10,
          searchKey: "",
        });

        SetDepost(depotData);
        SetProduct(productData);
        Setvehicle(vehicleData);
        setCustomer(customerData);
        setIsLoading(false);
      } catch (error) {
        console.error("Data fetching failed", error);
        setSuccessMessage("Error fetching dropdown data");
        setIsLoading(false);
      }
    }

    fetchData();
  }, []);

  // Get the depot and its address
  const depot = Array.isArray(depots)
    ? depots.find((d) => Number(d.depot_id) === depotId)
    : null;
  const depotAddress = depot?.depot_address || 'Depot address not found';

  // GSTIN: Bangalore depot has a different GST number
const isBangaloreDepot = /bangalore|bengaluru/i.test(
  `${depot?.depot_name || ''} ${depot?.depot_address || ''}`
);
const depotGstin = isBangaloreDepot ? '29AADCT2097G1Z3' : '27AADCT2097G1Z7';

  // Get depot name for to_depot_id
  const depotName = Array.isArray(depots)
    ? depots.find(c => Number(c.depot_id) === Number(to_depot_id))?.depot_name
    : 'N/A';

  // ── Point 3: customer code lookup (fields confirmed from DeliveryChallanAdd.jsx: cust_id / cust_code) ──
  const customerCode = Array.isArray(customer)
    ? customer.find(c => Number(c.cust_id) === Number(to_customer_id))?.cust_code
    : null;

  // Get vehicle number with fallback
 const vehicleno = unregistered_vehicle
    ? unregistered_vehicle
    : (vehicle_no || (Array.isArray(vehicle)
        ? vehicle.find(p => Number(p.vehicle_id) === Number(vehicle_id))?.vehicle_no
        : null) || 'Unknown Vehicle');

  // Get driver name with fallback
  const displayDriverName = unregistered_driver 
    ? unregistered_driver 
    : (driver_name || 'Nitin Mane');

  // Parse table_details
  const childRows = JSON.parse(table_details || '[]');

  const dateConversion = (date) => {
    if (!date) return 'N/A';
    var today = new Date(date);
    var dd = String(today.getDate()).padStart(2, "0");
    var mm = String(today.getMonth() + 1).padStart(2, "0");
    var yyyy = today.getFullYear();
    return `${dd}/${mm}/${yyyy}`;
  };

  useEffect(() => {
    if (entry_no) {
      document.title = `DC_${entry_no}`;
    } else {
      document.title = 'Delivery_Challan';
    }
  }, [entry_no]);

  const getProductCodes = () => {
    if (!Array.isArray(childRows) || !Array.isArray(products)) {
      return product_code || 'None';
    }

    const productCountMap = {};
    childRows.forEach(row => {
      const prodId = Number(row.prod_id);
      productCountMap[prodId] = (productCountMap[prodId] || 0) + 1;
    });

    const result = Object.entries(productCountMap).map(([prodId, count]) => {
      const product = products.find(p => Number(p.prod_id) === Number(prodId));
      if (product) {
        return `${product.prod_code} (${count})`;
      }
      return null;
    }).filter(Boolean);

    return result.length > 0 ? result.join(', ') : product_code || 'None';
  };

  if (isLoading) {
    return <Typography>Loading...</Typography>;
  }

  const getCustomerCylinderCount = () => {
    if (!Array.isArray(childRows)) return 0;
    const customerCylinders = childRows.filter(row => row.owner !== 'TGPL').length;
    return customerCylinders || 0;
  };


  const getTGPLCylinderCount = () => {
    if (!Array.isArray(childRows)) return 0;
    const tgplCylinders = childRows.filter(row => row.owner === 'TGPL').length;
    return tgplCylinders || 0;
};
  const totalBillQty = childRows.reduce((sum, row) => sum + Number(row.bill_qty || 0), 0);

  // ── Point 3: inter-depot transfer detection + From/To values ──
  // customer_name present  -> DC going to a customer -> show customer code instead of name/address
  // customer_name absent   -> DC going to another depot -> show From (this depot) / To (target depot)
  const isInterDepotTransfer = !customer_name && !!depotName;
  const toDisplayValue = customer_name
    ? (customerCode || customer_name) // fallback to name if code not found
    : (depotName || 'N/A');

  // ── Point 4: 3 columns x 20 rows per column = 60 cylinders per page ──
  const COLUMN_COUNT = 3;
  const ROWS_PER_COLUMN = 20;
  const columnWidth = 12 / COLUMN_COUNT; // xs grid width per column


  const PER_PAGE = COLUMN_COUNT * ROWS_PER_COLUMN; // 60
const pages = [];
for (let i = 0; i < childRows.length; i += PER_PAGE) {
  pages.push(childRows.slice(i, i + PER_PAGE));
}
if (pages.length === 0) pages.push([]);

  return (
    <Box className="print-source" style={{ margin: '0px 10px 10px 10px' }}>
      {/* ── height:'90vh' removed — that fixed height was squeezing the 3-column table and causing scroll/clipping in print ── */}
      <Box sx={{ margin: '0px 10px 10px 10px', boxShadow: 'none', height: 'auto', backgroundColor: '#ffffff', paddingLeft: '20px !important' }}>
        <Grid container>
          <Grid item xs={10}>
          <Box style={{
              backgroundImage: `url(${qoiImg})`,
              backgroundRepeat: 'no-repeat',
              backgroundSize: 'cover',
              backgroundPosition: 'center',
              height: '60px',
              width: '100% !important',
              display: 'flex',
              textAlign: 'center',
              alignItems: 'center'
            }}>
              <Typography sx={{ textAlign: 'start', textAlign: 'center', marginLeft: '10px', fontSize: '26px', fontWeight: 'bold', padding: '1px', color: '#ffffff', textTransform: 'uppercase' }}>
                Delivery Challan
              </Typography>
          </Box>
        <Box>
              <Typography sx={{ fontWeight: 'bold', fontSize: '18px' }}>
                TRI GASES PVT. LTD.
              </Typography>
              <Typography sx={{ fontSize: '12px' }}>
                {depotAddress}
              </Typography>
              <Typography sx={{ fontSize: '12px' }}>
                Email - demotes1234@gmail.com
              </Typography>
              <Typography sx={{ fontSize: '12px' }}>
                Website - www.trigases.com
              </Typography>
             <Typography sx={{ fontSize: '12px' }}>
  GSTIN - {depotGstin}
</Typography>
            </Box>
          </Grid>
          <Grid item xs={2}>
            <Box sx={{ justifyContent: 'flex-end', alignItems: 'flex-end', width: '100%', display: 'flex' }}>
              <img src={trigaslogo} style={{ width: 'auto', height: '150px', justifyContent: 'flex-end', display: 'flex' }} />
            </Box>
          </Grid>
          {/* ── Point 1: divider REMOVED from here (was above Date/DC block) ── */}
        </Grid>
        <Box>
          <Grid container spacing={0.6}>
            <Grid item xs={12} sm={7}>
              {/* ── Point 3: From/To format for ALL DCs — customer or inter-depot ── */}
<Box className={`${styles.print_label_container}`}>
  <Typography className={styles.info_txt2}>From :</Typography>
  <Typography className={styles.info_txt_ans2}>{depot?.depot_name || 'N/A'}</Typography>
</Box>
<Box className={`${styles.print_label_container}`}>
  <Typography className={styles.info_txt2}>To :</Typography>
  <Typography sx={{ fontWeight: 'bold', fontSize: '16px' }}>
    {toDisplayValue}
  </Typography>
</Box>

{customer_name && delivery_address && (
  <Typography className={styles.info_txt_ans2} sx={{ fontSize: '12px', maxWidth: '260px' }}>
    {delivery_address}
  </Typography>
)}
            </Grid>
            <Grid item xs={12} sm={5}>
             <Box className={`${styles.print_label_container}`} sx={{ flexWrap: 'nowrap', gap: '16px' }}>
  <Box className={`${styles.print_label_container}`} sx={{ flexWrap: 'nowrap', whiteSpace: 'nowrap' }}>
    <Typography className={styles.info_txt2} sx={{ whiteSpace: 'nowrap' }}>DC No :</Typography>
    <Typography className={styles.info_txt_ans2} sx={{ whiteSpace: 'nowrap' }}>{entry_no || 'N/A'}</Typography>
  </Box>
  <Box className={`${styles.print_label_container}`} sx={{ flexWrap: 'nowrap', whiteSpace: 'nowrap' }}>
    <Typography className={styles.info_txt2} sx={{ whiteSpace: 'nowrap' }}>Date :</Typography>
    <Typography className={styles.info_txt_ans2} sx={{ whiteSpace: 'nowrap' }}>{dateConversion(entry_date)}</Typography>
  </Box>
</Box>
              <Box className={`${styles.print_label_container}`}>
                {/* <Box className={`${styles.print_label_container}`}>
                  <Typography className={styles.info_txt2}>PO No : </Typography>
                  <Typography className={styles.info_txt_ans2}>{po_no || 'N/A'}</Typography>
                </Box> */}
                {/* <Box className={`${styles.print_label_container}`}>
                  <Typography className={styles.info_txt2}>Date :</Typography>
                  <Typography className={styles.info_txt_ans2}>{dateConversion(po_date)}</Typography>
                </Box> */}
              </Box>
              <Box className={`${styles.print_label_container}`}>
                {/* <Box className={`${styles.print_label_container}`}>
                  <Typography className={styles.info_txt2}>SO No :</Typography>
                  <Typography className={styles.info_txt_ans2}>{so_no || 'N/A'}</Typography>
                </Box> */}
                {/* <Box className={`${styles.print_label_container}`}>
                  <Typography className={styles.info_txt2}>Date :</Typography>
                  <Typography className={styles.info_txt_ans2}>{dateConversion(so_date)}</Typography>
                </Box> */}
              </Box>
              <Box className={`${styles.print_label_container}`}>
                <Typography className={styles.info_txt2}>Invoice :</Typography>
                <Typography className={styles.info_txt_ans2}>{invoice_no || 'N/A'}</Typography>
              </Box>
              <Box className={`${styles.print_label_container}`}>
                <Typography className={styles.info_txt2}>Vehicle :</Typography>
                <Typography className={styles.info_txt_ans2}>{vehicleno}</Typography>
              </Box>
              <Box className={`${styles.print_label_container}`}>
                <Typography className={styles.info_txt2}>Driver :</Typography>
                <Typography className={styles.info_txt_ans2}>{displayDriverName}</Typography>
              </Box>
            </Grid>
          </Grid>

          {/* ── Point 1: divider MOVED here — now below Date/DC info, above the cylinder table ── */}
          <Grid container>
            <Grid item xs={12} sx={{ borderTop: '1px solid #616161', backgroundColor: '#f0f0f0', minHeight: '10px', marginTop: '8px', marginBottom: '8px' }}></Grid>
          </Grid>
        </Box>
      <TableContainer component={Paper} className={`${styles.list_tbl_container}`} sx={{ boxShadow: 'none', overflowX: 'visible', overflowY: 'visible' }}>
  {pages.map((pageRows, pageIndex) => (
    <Box
      key={pageIndex}
      sx={{
        pageBreakAfter: pageIndex < pages.length - 1 ? 'always' : 'auto',
        breakAfter: pageIndex < pages.length - 1 ? 'page' : 'auto',
        pageBreakInside: 'avoid',
        breakInside: 'avoid',
      }}
    >
      <Grid container spacing={1}>
        {Array.from({ length: COLUMN_COUNT }, (_, colIndex) => {
          const start = colIndex * ROWS_PER_COLUMN;
          const colRows = pageRows.slice(start, start + ROWS_PER_COLUMN);

          // skip empty 2nd/3rd tables; always keep the first
          if (colRows.length === 0 && colIndex > 0) return null;

          return (
            <Grid item xs={columnWidth} md={columnWidth} key={colIndex}>
              <Table size="small" sx={{ tableLayout: 'fixed', width: '100%' }}>
                <TableHead>
                  <StyledTableRow>
                    <StyledTableCellPrint align="center" className="dc-print-table-head">Sr no</StyledTableCellPrint>
                    <StyledTableCellPrint align="center" className="dc-print-table-head">Cyl No</StyledTableCellPrint>
                    <StyledTableCellPrint align="center" className="dc-print-table-head">Type</StyledTableCellPrint>
                    <StyledTableCellPrint align="center" className="dc-print-table-head">Owner</StyledTableCellPrint>
                  </StyledTableRow>
                </TableHead>
                <TableBody>
                  {colRows.map((row, i) => (
                    <StyledTableRow key={i}>
                      <StyledTableCellPrint align="center" className="dc-print-table-body">
                        {pageIndex * PER_PAGE + start + i + 1}
                      </StyledTableCellPrint>
                      <StyledTableCellPrint align="center" className="dc-print-table-body">
                        {row.cyl_no}
                      </StyledTableCellPrint>
                      <StyledTableCellPrint align="center" className="dc-print-table-body">
                        {row.status || 'N/A'}
                      </StyledTableCellPrint>
                      <StyledTableCellPrint align="center" className="dc-print-table-body">
                        {row.owner}
                      </StyledTableCellPrint>
                    </StyledTableRow>
                  ))}
                </TableBody>
              </Table>
            </Grid>
          );
        })}
      </Grid>
    </Box>
  ))}
</TableContainer>
        <br />
        <Box style={{ borderTop: '1px solid #616161', backgroundColor: '#f0f0f0', minHeight: '10px' }}></Box>
        <Box sx={{ textAlign: 'left' }}>
          <Grid container>
            <Grid item xs={8}></Grid>
          </Grid>
        </Box>
    <Box className={`${styles.footer} dc-print-footer`}>
          <Table className={`${styles.footerTable}`}>
            <TableBody>
              <TableRow>
                <TableCell sx={{ paddingLeft: '0px !important', marginLeft: '0px !important', paddingRight: '0px !important', marginRight: '0px !important' }}>
                  <Box sx={{ padding: '0px !important', margin: '0px !important' }}>
                    <Box className={`${styles.summaryItem}`} sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'row' } }}>
                      <Typography className={`${styles.label_Txt_add}`}>
                        TGPL Cyl:
                      </Typography>
                      <Typography className={`${styles.summary_ans}`}>
                       {getTGPLCylinderCount()}
                      </Typography>
                    </Box>
                    <Box className={`${styles.summaryItem}`} sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'row' } }}>
                      <Typography className={`${styles.label_Txt_add}`}>
                        Customer Cyl:
                      </Typography>
                      <Typography className={`${styles.summary_ans}`}>
                        {getCustomerCylinderCount()}
                      </Typography>
                    </Box>
                    <Box className={`${styles.summaryItem}`} sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'row' } }}>
                      <Typography className={`${styles.label_Txt_add}`}>
                        Total Qty:
                      </Typography>
                      <Typography className={`${styles.summary_ans}`}>
  {Number(totalBillQty).toFixed(2)} m³s
</Typography>

                    </Box>
                  </Box>
                </TableCell>
                <TableCell>
                  <Box>
                    <Box sx={{ mt: 9 }}>
                      <Typography className={`${styles.authorized_txt}`}>
                        Receiver Signatory
                      </Typography>
                    </Box>
                  </Box>
                </TableCell>
                <TableCell>
                  <Box>
                    <Typography className={`${styles.footer_txt}`}>
                      For <span className={`${styles.footer_txt_bold}`}>TRI GASES PVT. LTD.</span>
                    </Typography>
                    <Box sx={{ mt: 7 }}>
                      <Typography className={`${styles.authorized_txt}`}>
                        Authorized Signatory
                      </Typography>
                    </Box>
                  </Box>
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </Box>
      </Box>
    </Box>
  );
});

export default DeliveryChallanPrint;